import type React from 'react';

// Mark an element with ref or id and use this function to make a smooth scroll. Prefer using ref - it can be passed as a prop.
// Use id only to avoid passing ref through multiple components.
export const scrollToElementByRefOrId = (ref: React.RefObject<HTMLElement | null> | null, elementId = '') => {
    if (ref && ref?.current) ref.current.scrollIntoView({ behavior: 'smooth' });

    const element = document.getElementById(elementId);

    if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        console.warn(`Element with id "${elementId}" not found.`);
    }
};

// pass ids or refs - in case or refs you need to check first if ref.current is available
// offset can have both positive and negative values, positive - scroll further past element, negative - scroll above element
export const scrollToElementByRefOrIdOffset = (scrollableContainer: HTMLElement, element: HTMLElement, offset = 0) => {
    const elementTop = element.offsetTop;

    scrollableContainer.scrollTo({
        top: elementTop + offset,
        behavior: 'smooth',
    });
};

export const getCurrentScrollTopPosition = (querySelector: string): number => {
    const element = document.querySelector<HTMLElement>(querySelector);

    return element ? element.scrollTop : 0;
};
